import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Footer from "./Footer";

function Layout({ children }) {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <div className="min-h-screen bg-dark-bg flex flex-col">
      {/* Header */}
      <header className="relative z-10 bg-dark-surface border-b border-dark-border">
        <div className="flex items-center justify-between px-4 sm:px-8 h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3">
            <div className="w-9 h-9 flex items-center justify-center">
              <svg viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
                <rect x="2" y="8" width="6" height="20" rx="1" fill="#d4a012"/>
                <rect x="11" y="14" width="6" height="14" rx="1" fill="#d4a012" opacity="0.7"/>
                <rect x="20" y="6" width="6" height="22" rx="1" fill="#d4a012"/>
                <rect x="29" y="12" width="6" height="16" rx="1" fill="#d4a012" opacity="0.7"/>
                <path d="M5 18L14 12L23 16L32 8" stroke="#26a269" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <circle cx="32" cy="8" r="3" fill="#26a269"/>
              </svg>
            </div>
            <span className="font-mono text-lg font-semibold tracking-tight text-dark-text">
              DayTrading<span className="text-accent-gold">Bench</span>
            </span>
          </Link>

          {/* Mobile hamburger button */}
          <button
            type="button"
            className="md:hidden inline-flex items-center justify-center p-2 rounded-md text-dark-text-secondary hover:text-dark-text hover:bg-dark-tertiary focus:outline-none focus:ring-2 focus:ring-inset focus:ring-accent-gold"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <span className="sr-only">Open main menu</span>
            {mobileMenuOpen ? (
              <svg
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            ) : (
              <svg
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            )}
          </button>

          {/* Desktop Navigation Links */}
          <nav className="hidden md:flex items-center gap-2">
            <Link
              to="/"
              className={`btn ${
                isActive("/")
                  ? "btn-primary"
                  : "btn-ghost"
              }`}
            >
              Leaderboard
            </Link>
            <Link
              to="/docs"
              className={`btn ${
                location.pathname.startsWith("/docs")
                  ? "btn-primary"
                  : "btn-ghost"
              }`}
            >
              Docs
            </Link>
          </nav>
        </div>

        {/* Mobile menu */}
        {mobileMenuOpen && (
          <div className="md:hidden pb-4 px-4 border-t border-dark-border-subtle">
            <div className="flex flex-col gap-2 pt-4">
              <Link
                to="/"
                onClick={() => setMobileMenuOpen(false)}
                className={`btn ${
                  isActive("/")
                    ? "btn-primary"
                    : "btn-ghost"
                } justify-start`}
              >
                Leaderboard
              </Link>
              <Link
                to="/docs"
                onClick={() => setMobileMenuOpen(false)}
                className={`btn ${
                  location.pathname.startsWith("/docs")
                    ? "btn-primary"
                    : "btn-ghost"
                } justify-start`}
              >
                Docs
              </Link>
            </div>
          </div>
        )}
      </header>

      {/* Main Content */}
      <main className="flex-1 relative z-1 max-w-[1400px] mx-auto px-3 sm:px-8 py-4 sm:py-8">
        {children}
      </main>

      <Footer />
    </div>
  );
}

export default Layout;
